import type { ReactNode } from "react";
import type { Tone } from "../lib/status";

export function StatusPill({ label, tone }: { label: string; tone: Tone }) {
  return <span className={`status-pill ${tone}`}>{label}</span>;
}

export function RiskBadge({ level }: { level: string }) {
  const tone = level.toLowerCase();
  const cls =
    tone === "low" ? "low" : tone === "medium" ? "medium" : tone === "high" ? "high" : "";
  return <span className={`risk-badge ${cls}`}>{level}</span>;
}

export function MetricCard({
  label,
  value,
  hint,
  trailing,
}: {
  label: string;
  value: ReactNode;
  hint?: string;
  trailing?: ReactNode;
}) {
  return (
    <div className="metric-card">
      <div className="label">{label}</div>
      <div className="value">{value}</div>
      {(hint || trailing) && (
        <div className="hint" style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
          <span>{hint}</span>
          {trailing}
        </div>
      )}
    </div>
  );
}

export function SectionHeader({
  title,
  subtitle,
  action,
}: {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}) {
  return (
    <div className="panel-header">
      <div>
        <h2>{title}</h2>
        {subtitle ? <span>{subtitle}</span> : null}
      </div>
      {action}
    </div>
  );
}

export function EmptyState({ title, detail }: { title: string; detail: string }) {
  return (
    <div className="empty-state">
      <h3>{title}</h3>
      <p>{detail}</p>
    </div>
  );
}

export function StatusBanner() {
  return (
    <div className="status-banner" role="status">
      <span>Authenticated</span>
      <span aria-hidden="true">·</span>
      <span>Read-only</span>
      <span aria-hidden="true">·</span>
      <span>Simulation Mode</span>
      <span aria-hidden="true">·</span>
      <strong>Live Execution Disabled</strong>
    </div>
  );
}
